import { Alert, AlertDescription } from '@/components/ui/alert';

/** Inline destructive alert for a form-level error. Renders nothing when empty. */
export function FormError({ message }: { message?: string | null }) {
  if (!message) return null;
  return (
    <Alert variant="destructive" className="mb-5">
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
